const translation = {
  general: {
    minute_one: '{{ count }}分鐘',
    minute_other: '{{ count }}分鐘',
    hour_one: '{{ count }}小時',
    hour_other: '{{ count }}小時',
  },
  app: {
    exit: '離開',
    close: '關閉',
    footer: 'Powered by One Click Go Live Limited',
    'login-btn': '登入',
    'logout-btn': '登出',
    confirm: '確認',
  },
  login: {
    title: '用户登入',
    'email-label': '輸入電郵',
    'not-registered-remark': '如還未有註冊用戶，請輸入電郵地址並點擊以下「確認」按鈕',
    'otp-guide-title': '驗證碼已發送',
    'otp-label': '輸入您的一次性驗證碼',
    'otp-remark-1': '我們已將您的一次性驗證碼發送到以下電郵地址',
    'otp-remark-2': '請於 15 分鐘內完成登入步驟',
    'next-step': '下一步',
    'email-error': '電郵不正確，請重新登入',
    'unknown-error': '錯誤，請重新登入',
    'otp-error': '驗證碼不正確，請重新輸入',
    'otp-fatal-error': '驗證碼超時或驗證碼錯誤超過3次，請重新登入',
  },
  home: {
    title: '首頁',
  },
  event: {
    info: '詳情',
    'q-and-a': '問答',
    question: {
      placeholder: '設有問答環節，如您有任何提問，請在這裡輸入。',
      submit: '提交',
      'succeed-message': '感謝您的提問',
      'failed-message': '提交失敗，請稍後再試',
      'exceeds-char-limit-message': '最多可以輸入100個中文字（200字符）',
    },
    chatroom: '聊天室',
    polling: '投票',
    si: {
      english: '英語',
      cantonese: '粵語',
      putonghua: '普通話',
    },
    playback: {
      'error-title': '播放失敗',
      'error-message': '也許您的網絡不太穩定，或者您並沒有權限觀看此視頻',
    },
    'just-started': '剛剛開始',
    'started-ago': '{{age}}前開始',
    'concurrent-error-message': '您已經在其他設備登入',
    'connection-error-message': '網絡不穩定',
    'require-login-message': '如果您有權限觀看此視頻，請登入',
    'session-kicked-error-message': '您已經在其他設備登入，點擊以下按鈕在這設備觀看',
    'view-here': '在此觀看',
    unauthorized: '未授權觀看',
  },
  passcode: {
    label: '請輸入密碼',
    enter: '確定',
    remark: '如未取得密碼，請聯絡您的活動主辦單位查詢',
    error: '密碼不正確',
    'select-placeholder': '請選擇',
  },
  registration: {
    title: '以對話邁向和平與繁榮之路',
    'intro-1':
      '國際調解院（IOMed）是全球首個以條約為基礎、專門透過調解解決國際爭端的政府間組織，總部位於中國香港特別行政區。',
    'intro-2':
      '在此首屆IOMed全球系列活動中，香港特別行政區前後任律政司司長林定國資深大律師及袁國強資深大律師，將分享多年來支持調解的政策與法例發展的幕後故事，包括對成立國際調解院的支持。香港特別行政區所走過的道路，展示調解作為其核心特質之一，可為和平解決爭端提供可行而務實的替代方案，為這個充滿挑戰的世界帶來和平與繁榮。',
    'event-details': '活動詳情',
    'date-key': '日期',
    'time-key': '時間',
    'venue-key': '地點',
    'address-key': '地址',
    'language-key': '語言',
    'agenda-key': '議程',
    'speakers-key': '講者',
    'format-key': '形式',
    date: '2026年9月24日（星期四）',
    time: '下午6時至7時30分（香港時間）',
    'time-1': '上午9:30 – 下午12:40（早上9時開始登記）',
    'time-2': '下午12:40 – 下午2:30（交流午餐）',
    venue: '國際調解院總部',
    address: '香港灣仔告士打道123號（舊灣仔警署）',
    language: '英語或普通話（設即時人工智能屏幕翻譯）',
    agenda: '按<0>此</0>查看詳情',
    speakers: '按<0>此</0>查看詳情',
    'virtual-date': '2025年3月4日（星期二）',
    'virtual-time': '上午10:00至下午12:30（香港時間）',
    'virtual-format': '網上',
    'form-heading': '登記',
    'form-attendance-type': '出席形式',
    'attendance-physical': '實體',
    'attendance-online': '網上',
    'form-title': '稱謂',
    'form-first-name': '名字',
    'form-last-name': '姓氏',
    'form-job-title': '職位',
    'form-company': '公司／機構',
    'form-email': '電郵',
    'form-membership-number': '香港律師會會員編號（如適用）',
    'form-jurisdiction': '司法管轄區',
    'form-agree-pics': '本人已閱讀並同意<0>個人資料收集聲明</0>。',
    'form-agree-photo': '本人已閱讀並同意<0>活動照片及／或影片使用聲明</0>。',
    'form-agree-terms':
      '本人已閱讀並同意主辦單位上述<0>條款及細則</0>，並聲明以上資料正確無誤。本人知悉所提供的個人資料將作為主辦單位的聯絡資料。',
    'form-agree-marketing':
      '本人同意訂閱國際調解院電郵通訊，並同意收取國際調解院的最新消息、新聞及其他市場推廣通訊。本人亦同意經選定的第三方合作夥伴將本人的個人資料用於市場推廣用途。',
    copyright: '版權所有 © 國際調解院，保留所有權利',
    'pics-url': 'https://event.oneclickgolive.com/external/iomed/20260924/pics-en.pdf',
    'photo-url':
      'https://event.oneclickgolive.com/external/iomed/20260924/statement-of-use-photo-en.pdf',
    'terms-url': 'https://event.oneclickgolive.com/external/iomed/20260924/tnc-en.pdf',
    'data-protection-email': 'Data-protection@investhk.gov.hk',
    submit: '提交',
    'submit-succeed': '提交成功',
    'submit-failed': '提交失敗',
    'submit-failed-email': '提交失敗\n此電郵地址已經註冊',
    'please-select': '請選擇',
    'title-prof': '教授',
    'title-dr': '博士',
    'title-mr': '先生',
    'title-mrs': '夫人',
    'title-ms': '女士',
    'title-miss': '小姐',
    'title-others': '其他',
    'error-attendance-type': '請選擇出席形式',
    'error-title': '請選擇您的稱謂',
    'error-email': '請輸入您的電郵地址',
    'error-first-name': '請輸入您的名字',
    'error-last-name': '請輸入您的姓氏',
    'error-company': '請輸入您的公司',
    'error-jurisdiction': '請選擇司法管轄區',
    'error-agree-pics': '請接受個人資料收集聲明',
    'error-agree-photo': '請接受活動照片及／或影片使用聲明',
    'error-agree-terms': '請接受條款及細則',
  },
};

export default translation;
